import React from "react"
import "./morenumbers.css"


const moreNumbers = ( ) => {


    return (
        <section className="morenumbers" id="MoreNumbers">
            <div className="containfix">

                    <div>

                        <h1><span className="aigreen">AI</span> WEEK HAS PARTICIPATION FROM THE NATION'S TOP EXECUTIVES</h1>
                        <div className="theStats">
                            <div className="bigNum">59%</div><div className="bigNumtext">of Our Attendees Are Executives</div><br />
                            <div className="bigNum">41%</div><div className="bigNumtext">of Our Attendees Are Mid-Level Managers</div><br />

                        </div>

                        <h1>AUDIENCE BREAKDOWN BY TYPE:</h1>
                        <div className="theStats">
                            <div className="bigNum">60%</div><div className="bigNumtext">Federal Government</div><br />
                            <div className="bigNum">10%</div><div className="bigNumtext">State & Local Government</div><br />
                            <div className="bigNum">20%</div><div className="bigNumtext">Industry Executives</div><br />
                            <div className="bigNum">10%</div><div className="bigNumtext">Education</div><br />
                        </div>
                    </div>




            </div>

        </section>

    )
}
export default moreNumbers
